<div class="brief-table-wrap">
  <table class="brief-table">
    <thead>
      <tr>
        <th>Objective</th>
        <th>What We Need</th>
        <th>Outcome</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{{ brief.objective }}</td>
        <td>
          <ul class="need-list">
            <li *ngFor="let item of (requiredLabels ?? brief.whatWeNeed)">{{ item }}</li>
          </ul>
        </td>
        <td>{{ brief.outcome }}</td>
      </tr>
    </tbody>
  </table>
</div>
